import React from 'react';

import { styled } from '@gogame/components';
import { useNumberFormat, usePercentFormat } from '@gogame/intl-ts';

import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';

const CMetricValue = styled('span')`
  color: ${({ theme, less }) =>
    less ? theme.palette.error.main : theme.palette.success.main};
`;

const MetricGroup = ({ metric, typeField }) => {
  const { value, less } = useViewStateByResolveName(metric);
  const formatPercent = usePercentFormat();
  const formatNumber = useNumberFormat();

  const formattedValue = React.useMemo(
    () =>
      ({
        percent: formatPercent,
        number: formatNumber,
      })[typeField](Number(value)),
    [value, typeField]
  );

  return <CMetricValue less={less}>{formattedValue}</CMetricValue>;
};

export default MetricGroup;
